import React, { useEffect, useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "../../Images/georgia-access-logo-stacked.svg";
import theme from "../../theme";
import { AppBar } from "@mui/material";



export default function Header() {
  // Header-related code here
  return (
    <AppBar
      position="static"
      style={{ backgroundColor: theme.palette.background.default }}
    >
      <Toolbar
        sx={{
          pr: "24px", // keep right padding when drawer closed
        }}
      >
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          sx={{ flexGrow: 1 }}
        >
          <img
            src={Logo}
            alt="Georgia Access"
            style={{
              verticalAlign: "middle",
              height: "70%",
              padding: "10px",
            }}
          />
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
